export const ACTION_TYPES = {
  SEARCH_FOR_PARTICULAR_DEPARTMENT: 'SEARCH_FOR_PARTICULAR_DEPARTMENT',
  SEARCH_WITHOUT_CALL_NUMBER: 'SEARCH_WITHOUT_CALL_NUMBER',
  STORE_DEPARTMENT_DATA: 'STORE_DEPARTMENT_DATA',
  SELECTED_DEPARTMENT_NAME: 'SELECTED_DEPARTMENT_NAME',
  SELECTED_COMPANY_NAME: 'SELECTED_COMPANY_NAME',
  STORE_COMPANY_DATA: 'STORE_COMPANY_DATA',
  STORE_FILTERED_COMPANY_DATA: 'STORE_FILTERED_COMPANY_DATA',
  CLEAR_FILTER: 'CLEAR_FILTER',
  DISPOSE_FILTERS: 'DISPOSE_FILTERS',
  UPDATE_FILTERS_STATE: 'UPDATE_FILTERS_STATE',
};

export const STATE_HISTORY_OPERATIONS = {
  INIT: 'INIT',
  APPEND: 'APPEND',
  UNDO: 'UNDO',
  RESET: 'RESET',
};

export const initialState = {
  filters: [],
  filterData: {
    data: {},
    temp: {},
    active: null,
    queue: {},
  },
  selectedFiltersData: {
    data: {},
    temp: {},
    active: null,
    queue: {},
  },
  skipUpdate: {},
  searchForParticularDepartment: false,
  searchWithoutCallNumber: NaN,
  departmentData: [],
  sideCompanyDataFromStore: {},
  stateHistory: {},
  stateHistoryChanged: false,
  initialFilters: {},
};

const searchFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SEARCH_FOR_PARTICULAR_DEPARTMENT:
      return { ...state, searchForParticularDepartment: action.payload };
    case ACTION_TYPES.SEARCH_WITHOUT_CALL_NUMBER:
      return { ...state, searchWithoutCallNumber: action.payload };
    case ACTION_TYPES.SELECTED_DEPARTMENT_NAME:{
      const { companyInfo: { departments = [] } = {} } = state.companyData || {};
      const compareDepartment = departments.find((depart) => depart.department === action.payload);
      if (compareDepartment) {
        const { languages, ethnicities, genders, degrees, majors, schools, parties, contributors } =
          compareDepartment;
        return {
          ...state,
          companyData: {
            ...state.companyData,
            companyInfo: {
              ...(state.companyData?.companyInfo || {}),
              companyDiversity: {
                languages,
                ethnicities,
                genders,
              },
              companyEducation: {
                degrees,
                majors,
                schools,
              },
              companyPolicity: {
                parties,
                contributors,
              },
            },
          },
          departmentFilter: action.payload,
          originalLanguagesLength: languages && languages.length,
          originalGendersLength: languages && genders.length,
          originalEthnicitiesLength: languages && ethnicities.length,
          originalDegreeLength: degrees && degrees.length,
          originalMajorLength: majors && majors.length,
          originalSchoolsLength: schools && schools.length,
        };
      }

      return {
        ...state,
        departmentFilter: action.payload,
      };
    }
    case ACTION_TYPES.STORE_FILTERED_COMPANY_DATA: {
      return {
        ...state,
        filteredCompanyData: {
          logo: action.payload.companyLogoOriginal,
          companyID: action.payload.companyID,
          name: action.payload.companyNameCPS,
          departments: action.payload.departments,
          storeEducationData: action.payload.companyEducation,
          storeDiversityData: action.payload.companyDiversity,
          storePoliticalData: action.payload.companyPolicity,
          storeSalaryData: action.payload.companySalaries,
        },
      };
    }

    case ACTION_TYPES.SELECTED_COMPANY_NAME:
      return { ...state, companyFilter: action.payload };
    case ACTION_TYPES.STORE_DEPARTMENT_DATA:
      return {
        ...state,
        departmentData: action.payload,
      };
    case ACTION_TYPES.STORE_COMPANY_DATA:{
      const {
        companyInfo: {
          companyDiversity,
          companyEducation,
          companyPolicity,
          companySalaries,
        },
        defaultCompanyData,
      } = action.payload;
      const { languages, ethnicities, genders } = companyDiversity || {};
      const { degrees, majors, schools } = companyEducation || {};
      const { parties, contributors } = companyPolicity || {};

      return {
        ...state,
        companyData: action.payload,
        originalLanguagesLength: languages && languages.length,
        originalGendersLength: languages && genders.length,
        originalEthnicitiesLength: languages && ethnicities.length,
        originalDegreeLength: degrees && degrees.length,
        originalMajorLength: majors && majors.length,
        originalSchoolsLength: schools && schools.length,
        filteredCompanyData: defaultCompanyData
          ? {
              logo: defaultCompanyData[0].companyLogoOriginal,
              name: defaultCompanyData[0].companyNameCPS,
              storeEducationData: defaultCompanyData[0].companyEducation,
              storeDiversityData: defaultCompanyData[0].companyDiversity,
              storePoliticalData: defaultCompanyData[0].companyPolicity,
              storeSalaryData: defaultCompanyData[0].companySalaries,
            }
          : {},
        originalCompanyDiversity: {
          languages,
          ethnicities,
          genders,
        },
        originalCompanyEducation: {
          degrees,
          majors,
          schools,
        },
        originalCompanyPolicity: {
          parties,
          contributors,
        },
        originalCompanySalaries: companySalaries,
      };
    }
    case ACTION_TYPES.CLEAR_FILTER: {
      const originalCompanyDetails = {
        ...state.companyData,
        companyInfo: {
          ...(state.companyData?.companyInfo || {}),
          companyDiversity: {
            ...state.originalCompanyDiversity,
          },
          companyEducation: {
            ...state.originalCompanyEducation,
          },
          companyPolicity: {
            ...state.originalCompanyPolicity,
          },
          companySalaries: {
            ...state.originalCompanySalaries,
          },
        },
      };
      const {
        companyInfo: { companyDiversity, companyEducation },
      } = originalCompanyDetails;
      const { languages, ethnicities, genders } = companyDiversity;
      const { degrees, majors, schools } = companyEducation;
      return {
        ...state,
        companyData: originalCompanyDetails,
        originalLanguagesLength: languages && languages.length,
        originalGendersLength: languages && genders.length,
        originalEthnicitiesLength: languages && ethnicities.length,
        originalDegreeLength: degrees && degrees.length,
        originalMajorLength: majors && majors.length,
        originalSchoolsLength: schools && schools.length,
      };
    }
    case ACTION_TYPES.DISPOSE_FILTERS: {
      return {
        ...state,
        filters: action.payload,
      };
    }
    case ACTION_TYPES.UPDATE_FILTERS_STATE:{
      let stateHistory = state.stateHistory[action.filterGroup];
      switch (action.operation) {
        case STATE_HISTORY_OPERATIONS.INIT:
          stateHistory = [action.newState];
          break;
        case STATE_HISTORY_OPERATIONS.APPEND:
          stateHistory.push(action.newState);
          break;
        case STATE_HISTORY_OPERATIONS.UNDO:
          stateHistory.pop();
          break;
        case STATE_HISTORY_OPERATIONS.RESET:{
          const [first] = stateHistory;
          stateHistory = [first];
          break;
        }
      }
      return {
        ...state,
        stateHistoryChanged:
          state.stateHistoryChanged || action.operation === STATE_HISTORY_OPERATIONS.APPEND,
        stateHistory: {
          ...state.stateHistory,
          [action.filterGroup]: stateHistory,
        },
      };
    }
    default:
      return state;
  }
};

export default searchFilterReducer;
